window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  // window.Popper = require('popper.js').default;
  global.$ = global.jQuery = window.$ = window.jQuery = require('jquery');

  // require('bootstrap');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
  console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * There used to be a global axios response-error interceptor here. It was
 * removed, not replaced, because it did nothing useful and one thing harmful:
 *
 *   - Its only user-facing output - an app.$notify({...}) call - was commented
 *     out, so it computed an error message on every failed request and threw it
 *     away. No 4xx/5xx anywhere in the app produced any UI feedback.
 *   - It read `error.response.status` unconditionally *inside* the rejection
 *     handler, so any response-less failure (offline, timeout, cancelled
 *     request) reached callers as an unrelated TypeError instead of the real
 *     axios error.
 *
 * Components surface their own failures via buildHttpErrorNotification() in
 * ./http-error-notifier. Restoring a genuinely global toast is separate work:
 * 38 axios call sites across 17 components already render their own error
 * message, and @kyvg/vue3-notification renders one copy of every notify() per
 * mounted <notifications> host, so a blanket toast needs those call sites
 * audited and one page-level host mounted in the layout first.
 */
